const STATUS_CHANGE_PATTERN = /^(\w+)\s*→\s*(\w+)$/;

export function formatActivityBody(activity, t) {
  const body = activity?.body;
  if (!body) return null;

  if (activity.type === 'status_change') {
    const match = body.match(STATUS_CHANGE_PATTERN);
    if (match) {
      const [, fromKey, toKey] = match;
      return t('leads.statusChangeBody', {
        from: t(`leads.status.${fromKey}`),
        to: t(`leads.status.${toKey}`),
      });
    }
  }

  return body;
}
